SP.lang.Class.define("SP.sitekit.form.validator.FileMimeType", {

	_options: null,

	init: function (options) {
		this._options = options;
	},

	isValid: function (value, el) {

		var me = this;

		var file = el.files.length >= 1 ? el.files[0] : null;
		if (file !== null) {

			var valid;

			if (me._options.includes) {
				valid = false;
				SP.lang.Array.each(me._options.includes, function(i, mimePattern) {
					if (me.matchMime(file.type, mimePattern)) {
						valid = true;
						return false;
					}
				});
				if (!valid) {
					return false;
				}
			}

			if (me._options.excludes) {
				valid = true;
				SP.lang.Array.each(me._options.includes, function(i, mimePattern) {
					if (me.matchMime(file.type, mimePattern)) {
						valid = false;
						return false;
					}
				});
				if (!valid) {
					return false;
				}
			}
		}
		return true;
	},

	matchMime: function(mime, pattern) {
		var pos = pattern.indexOf("/*");
		if (pos !== -1) {
			pattern = pattern.substring(0, pos);
			if (mime.startsWith(pattern)) {
				return true;
			}
		} else if (mime === pattern) {
			return true;
		} else {
			return false;
		}
	},

	getMessage: function () {
		return this._options.messages.fileMimeType;
	}

});
